export const link = () => (
  <path
    d="M15 7h3a5 5 0 110 10h-3m-6 0H6A5 5 0 116 7h3m-1 5h8"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
);
